import { useState, useEffect } from "react";

interface Props {
  message: string;
  onClose: () => void;
  duration?: number;
}

export function AuthErrorToast({ message, onClose, duration = 5000 }: Props) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleBackdropClick = () => {
    setIsVisible(false);
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={handleBackdropClick}
      />
      <div
        className="relative bg-black border border-red-500/20 rounded-lg p-8 shadow-2xl max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-white/60 hover:text-white"
          onClick={handleBackdropClick}
        >
          ×
        </button>
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="bg-red-500/10 rounded-full p-3">
            <svg
              className="w-10 h-10 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-red-400">
            Authentication Error
          </h2>
          <p className="text-white/80">{message}</p>
        </div>
      </div>
    </div>
  );
}
